import HeroLayout from "../../../Components/LayoutContainers/HeroLayout";
import MDBox from "../../../Components/MDBox";
import ESLF from "../../../Asset/images/noskhe.png";
 
import React, {useEffect, useState} from "react";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import {NoskheModel} from "../../../Api/Model/NoskheModel";
import Cookies from "js-cookie";
import {UserModel} from "../../../Api/Model/UserModel";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import {ErrorToaast} from "../../../utils/toast/Toast";
import MDTypography from "../../../Components/MDTypography";
import {ButtonBase, Grid, TableBody, TableContainer, TableHead, TablePagination, TableRow} from "@mui/material";
import Paper from "@mui/material/Paper";
import {Table} from "reactstrap";
import MDTableCell from "../../../Components/MDTable/MDTableCell";
import MDTableRow from "../../../Components/MDTable/MDTableRow";
import {v4 as uuid} from "uuid";
import {useNavigate} from "react-router-dom";

export default function StudentNoskhe(){
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [controller, dispatch] = useMaterialUIController();
    const [studentShowMedalDialog, setStudentShowMedalDialog] = useState({open: false, model: null});
const navigate = useNavigate();
    const {loading} = controller;
    let Api = new NoskheModel(Cookies.get("cst") ?? "");
    let UserApi = new UserModel(Cookies.get("cst") ?? "");

    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });

    useEffect(() => {
        setLoading(dispatch, true);
        Api
            .getAllWithPaginate(CurrentUser()?.user.id, pageNumber, pageSize)
            .then((r) => {
                setRows(r.data.data);
            })
            .then(() => {
                UserApi
                    .GetMedal(CurrentUser()?.user.id)
                    .then((r) => {
                        setStudentShowMedalDialog({model: r.data.data, open: true})
                    })
                    .catch(() => {
                        ErrorToaast("خطا در دریافت اطلاعات")
                    });
            })
            .catch(r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })
            .finally(() => {
                setLoading(dispatch, false);
            });


    }, [pageNumber, pageSize, counter]);
    const handleChangePage = (event, newPage) => {
        setPageNumber(newPage + 1);
    };
    const handleChangeRowsPerPage = (
        event
    ) => {
        setPageSize(+event.target.value);
        setPageNumber(1);
    };

    function defaultLabelDisplayedRows({from, to, count}) {
        return `${from}–${to} از ${
            count !== -1 ? count : `بیشتر از ${to}`
        }`;
    }

    function handleClickOpen(msg) {
        setNoskhedialog({msg, open: true})

    }

    function handleCloseNoskhe() {
        setNoskhedialog({msg: null, open: false})

    }
    return<HeroLayout>
        <MDBox mx={{xs: 2, md: 10, lg: 10}} mt={4}  >
            <MDBox sx={{justifySelf: "center"}}>
                <img src={ ESLF } style={{height: "15vh"}}/>
            </MDBox>
        </MDBox>
        <MDBox py={3}   p={2} mb={2} borderRadius={20}>
 
            <MDBox py={3}  p={2} mb={2} flex={1} borderRadius={2}>
                <Grid container flexDirection={"column"}>
                    <Grid item sx={{width: "100%"}}>
                        <TableContainer component={Paper} sx={{width: "100%"}}>
                            <Table sx={{minWidth: 700}} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نام پزشک
                                        </MDTableCell>

                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نام کاربری
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            تاریخ
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            عنوان نسخه
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            متن نسخه
                                        </MDTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows?.content.length < 1 && (
                                        <MDTableRow
                                            sx={{
                                                "&:last-child td, &:last-child th": {border: 0},
                                            }}
                                        >
                                            <MDTableCell colSpan={9} align="right">
                                                بدون اطلاعات
                                            </MDTableCell>
                                        </MDTableRow>
                                    )}
                                    {rows?.content?.map((r) => {
                                        return (
                                            <MDTableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={uuid()}
                                            >
                                                <MDTableCell align={"center"}>
                                                    {r?.doctorName + " " + r?.doctorLastName}
                                                </MDTableCell>

                                                <MDTableCell align={"center"}>
                                                    {r?.doctorUserName}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {new Date(r?.created).toLocaleString('fa-IR')}
                                                </MDTableCell>

                                                <MDTableCell align={"center"}>
                                                    {r?.title}
                                                </MDTableCell>

                                                <MDTableCell align={"center"} sx={{maxWidth: 250}}>
                                                    {r?.text}

                                                </MDTableCell>

                                            </MDTableRow>


                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {rows?.content.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={rows.totalPages}
                                rowsPerPage={pageSize}
                                page={pageNumber - 1}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelDisplayedRows={defaultLabelDisplayedRows}
                                labelRowsPerPage={<>تعداد در هر صفحه</>}
                            />
                        )}
                    </Grid>
                </Grid>

            </MDBox>
            <ButtonBase onClick={() => navigate("/studentlanding")}
                        sx={{borderRadius: "5px", height: 50,}}
                        disabled={loading}
                        type={"button"}>
                <MDTypography color={"black"} fontSize={"25px"} sx={{mr: 10}}>
                    بازگشت
                </MDTypography>
            </ButtonBase>
        </MDBox>
    </HeroLayout>
}